
export const ScrollToId = (id:string) => {
    window.history.pushState(null, "", id)        
    const el = document.querySelector(id)
    el?.scrollIntoView({behavior:'smooth'})
    
}